// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"81044555","239":"7edd1da6","455":"032dc936"}[chunkId] + ".chunk.js";
};